/**
 * @file: 三角形感叹号图标
 * icon-wraning
 * https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.13&manage_type=myprojects&projectId=721231&keyword=&project_type=&page=
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/03      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
const IconWraning = ({size=14}) => {
        return (
            <img className="iconfont" width={size}
                src={"https://oss.essaone.com/b5a981eb-0ba4-4f7e-b56a-b99a730b39b0.svg"}></img>
        );
}

export default IconWraning;
